import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as partnerActions from '../../actions/partnerActions';

/*
Component to load partner state (from the Auth app).
Should be included in all pages
*/
export class PartnerData extends Component {
  componentDidUpdate(prevProps) {
    // only fetch partner data from funding if user is partner
    const {role} = this.props.user;
    const isPartner = Array.isArray(role) ? role.includes('partner') : role === 'partner';
    if (prevProps.user !== this.props.user && isPartner) {
      this.props.partnerActions.fetchPartner(this.props.user.relationship_id);
    }
  }

  render() {
    return null;
  }
}

PartnerData.propTypes = {
  partnerActions: PropTypes.object,
  user: PropTypes.object,
  partner: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    user: state.user,
    partner: state.partner
  };
}

function mapDispatchToProps(dispatch) {
  return {
    partnerActions: bindActionCreators(partnerActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerData);
